var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"ConfigRecaptcha"}},[_c('b-row',[_c('b-col',[_c('h2',{staticClass:"pb-3"},[_vm._v("ReCaptcha Configuration")])])],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-tabs',{attrs:{"lazy":""}},[_c('b-tab',{attrs:{"title":"Use ReCaptcha","active":""}},[_c('ConfigRecaptchaUse')],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-207e5ad0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/config/ConfigRecaptcha.vue
// module id = null
// module chunks = 